import { createReducer, createAction } from "redux-act";
import * as app from "./app";

const SAVE_ATTACHMENT_FORM_REQUEST = `${
  app.NS
}account/save_attachment_form_request`;
export const SAVE_ATTACHMENT_FORM_REQUEST_ACTION = createAction(
  SAVE_ATTACHMENT_FORM_REQUEST
);
const SAVE_ATTACHMENT_FORM_SUCCESS = `${
  app.NS
}account/save_attachment_form_success`;
export const SAVE_ATTACHMENT_FORM_SUCCESS_ACTION = createAction(
  SAVE_ATTACHMENT_FORM_SUCCESS
);
const SAVE_ATTACHMENT_FORM_FAILURE = `${
  app.NS
}account/save_attachment_form_failure`;
export const SAVE_ATTACHMENT_FORM_FAILURE_ACTION = createAction(
  SAVE_ATTACHMENT_FORM_FAILURE
);

export const saveAttachmentFormRequest = id => {
  const action = SAVE_ATTACHMENT_FORM_REQUEST_ACTION(id);
  return action;
};
export const saveAttachmentFormSuccess = user => {
  const action = SAVE_ATTACHMENT_FORM_SUCCESS_ACTION(user);
  return action;
};

export const saveAttachmentFormFailure = error => {
  const action = SAVE_ATTACHMENT_FORM_FAILURE_ACTION(error);
  return action;
};



// WEBPACK FOOTER //
// ./src/ducks/attachments.js